<template>
    <div class="container">
        <div class="row doc-display" style="margin-top: 45px;">
            <div class="col-lg-3">
                <h2>Docs</h2>
                <ul>
                    <li v-for="link in docs" :key="link.path">
                        <a :href="link.path">
                            {{link["menu-title"]}}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-9 doc-content">
                <h1 style="font-size: 40px;">{{ doc.title }}</h1>
                <article>
                    <nuxt-content :document="doc" />
                </article>
            </div>
        </div>
    </div>
</template>

<style>
    /* .doc-display ul {
        list-style-type: none;
        padding-left: 10px;
    } */

    /* we display .katex-mathml since mathjax is prettier. Hide this one */
    .katex-html {
        display: none;
    }
</style>

<script>
import createHeader from "../../js/meta.js";

export default {
    async asyncData({ $content, params, error, redirect }) {
        console.log("slug: #" + params.slug + "#");
        if (!params.slug) {
            try {
                const docs = await $content("docs")
                    .sortBy("order", "asc")
                    .fetch();

                // if we just went on the "/docs" url, redirect to the first doc
                if( docs[0] && docs[0].path ) {
                    redirect(docs[0].path);
                }
                else {
                    console.error("No document found");
                }
            } catch (e) {
                console.log(e);

                error({
                    statusCode: 404,
                    message: "This course doesn't exist",
                });
            }
        } else {
            try {
                const doc = await $content("docs", params.slug).fetch();
                console.log("doc: " + doc);
                const docs = await $content("docs").sortBy("order", "asc").fetch();
                console.log(docs);

                return {
                    doc: doc,
                    docs: docs
                };
            } catch (e) {
                error({
                    statusCode: 404,
                    message: "This documentation doesn't exist",
                });
            }
        }
    },
    head() {
        let head = createHeader({
            title: this.doc.title,
            description: this.doc.description,
            imageUrl: this.doc.img,
        });

        return head;
    },
    mounted() {
        // interpret all mathjax when mounted
        //MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
    }
};
</script>
